/**
 * Returns "spring" | "summer" | "fall" | "winter"
 * based on the current month
 */
export function currentSeason() {
  const m = new Date().getMonth(); // 0 = Jan, 11 = Dec
  if (m >= 2 && m <= 4) return 'spring';
  if (m >= 5 && m <= 7) return 'summer';
  if (m >= 8 && m <= 10) return 'fall';
  return 'winter';
}

/** Capitalize first letter: "spring" → "Spring" */
export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
